// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"871":"f5a7d7ac","884":"5fad68da","993":"6ee2e3d8"}[chunkId] + ".chunk.css";
};